"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaContainerProperty = exports.ctaContainerPropertyDefinition = void 0;
exports.ctaContainerPropertyDefinition = {
    view: { label: 'CTA\'s' },
    constraints: [
        {
            name: 'properties',
            argument: ['cta-url', 'cta-asset'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'cta-container',
};
const isCtaContainerProperty = (prop) => {
    return prop.name === exports.ctaContainerPropertyDefinition.name;
};
exports.isCtaContainerProperty = isCtaContainerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLWNvbnRhaW5lci5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2N0YS1jb250YWluZXIucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBS2EsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFO0lBQ3pCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFlBQVk7WUFDbEIsUUFBUSxFQUFFLENBQUMsU0FBUyxFQUFFLFdBQVcsQ0FBQztTQUNuQztLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsZUFBZTtDQUNVLENBQUE7QUFNMUIsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLElBQWtCLEVBQWdDLEVBQUU7SUFDekYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHNDQUE4QixDQUFDLElBQUksQ0FBQTtBQUMxRCxDQUFDLENBQUE7QUFGWSxRQUFBLHNCQUFzQiwwQkFFbEMifQ==